import React from 'react';
import PropTypes from 'prop-types';

const icons = {
  bar: require('img/chart/chart-bar.svg'),
  line: require('img/chart/chart-line.svg'),
};

export default function ChartTypeToggle({ value = 'bar', onChange, labels = {} }) {
  const options = [
    { key: 'bar', name: labels.bars || 'Bars' },
    { key: 'line', name: labels.lines || 'Lines' },
  ];

  return (
    <div className="chart-type-toggle">
      {options.map((opt) => (
        <button
          key={opt.key}
          type="button"
          className={`chart-type-chip ${value === opt.key ? 'active' : ''}`}
          onClick={() => onChange && onChange(opt.key)}
        >
          <img src={icons[opt.key]} alt={opt.name} />
          <span>{opt.name}</span>
        </button>
      ))}
    </div>
  );
}

ChartTypeToggle.propTypes = {
  value: PropTypes.oneOf(['bar', 'line']),
  onChange: PropTypes.func,
  labels: PropTypes.object,
};


